import { render, staticRenderFns } from "./videoLibrary.vue?vue&type=template&id=63b43ef9&scoped=true&"
import script from "./videoLibrary.vue?vue&type=script&lang=js&"
export * from "./videoLibrary.vue?vue&type=script&lang=js&"
import style0 from "./videoLibrary.vue?vue&type=style&index=0&id=63b43ef9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b43ef9",
  null
  
)

export default component.exports